import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  erro: boolean;
}

// Rede de proteção por pergunta: se UM campo quebrar durante o render,
// aparece só o aviso no lugar dele e o resto da ficha continua funcionando.
export default class ProtecaoPergunta extends Component<Props, State> {
  state: State = { erro: false };

  static getDerivedStateFromError(): Partial<State> {
    return { erro: true };
  }

  componentDidCatch(erro: unknown): void {
    // Fica no console para depuração, sem atrapalhar a pessoa.
    // eslint-disable-next-line no-console
    console.error('[Ficha] Não foi possível mostrar esta pergunta:', erro);
  }

  render() {
    if (this.state.erro) {
      return (
        <div className="flex items-start gap-2 rounded-md bg-background-100 px-3 py-3">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center text-secondary-500">
            <i className="ri-error-warning-line" aria-hidden />
          </span>
          <p className="text-sm text-secondary-600">Não foi possível mostrar esta pergunta.</p>
        </div>
      );
    }
    return this.props.children;
  }
}